<template>
  <div class="brandSite">
    <div class="brandSite--container" v-for="(item, index) in cabecalho" :key="index">
      <div class="brandSite--logo" @click="navDisable">
        <router-link
        to="/"
        :title='item.title'
        class="brandSite--link">
          <img :src="item.imgMedium" :alt="item.title">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { apis } from '@/api.js'

export default {
  name: 'BrandSite',
  components: {
  },
  data () {
    return {
      url: apis.api.cabecalhoAPI,
      cabecalho: ''
    }
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.cabecalho = response
        })
    },
    navDisable () {
      let html = document.body.parentNode
      html.classList.remove('navActive')
    }
  },
  created () {
    this.getApi()
  }
}
</script>

<style>

</style>
